import { all, call, put, takeEvery } from "redux-saga/effects";
import AquaaActionTypes from "../../constants/Applications/aquaa-actionTypes";
import { getAccountEvaluatorAccountsDataService, getAccountEvaluatorTableDataService, getAccountEvaluatorUsersDataService, getAdditionalReciepientsDataService, getAgentEvaluationsDataService, getAquaaAccountsDataService, getAquaaAdminAccountsDataService, getAquaaAdminAccountsTableDataService, getAquaaAdminChannelsDataService, getAquaaAdminQuestionsTableDataService, getAquaaAgentsDataService, getAquaaAWSDataService, getAquaaChannelsDataService, getAquaaEvaluationsDeleteService, getAquaaIcedAccountsService, getAquaaIcedAgentsService, getAquaaIcedL1CategoryService, getAquaaIcedL2CategoryService, getAquaaIcedTableDataService, getAquaaLanguagesDataService, getAquaaLocationsDataService, getAquaaMappingAccountsService, getAquaaMappingContacttypeFormsService, getAquaaMappingCountriesService, getAquaaMappingParameterTypeService, getAquaaMappingQuestionsService, getAquaaMappingSectionsService, getAquaaNonASDAccountsDataService, getAquaaNonASDAgentsDataService, getAquaaNonASDChannelsDataService, getAquaaNonASDLanguagesDataService, getAquaaNonASDLocationsDataService, getAquaaQuestionAssessmentsDataService, getAquaaValidateTicketNoService, getAquaaValidFromDataService, getEvaluationFormDataService, getIcedMasterDataService, getIcedReportsAccountsDataService, getIcedTableDataService, getNonASDEvaluationFormDataService, getRecommendationsDropdownDataService, getRecommendationsTableDataService, getSavedEvaluationFormDataService, getSavedEvaluationsDataService, getSubmittedEvaluationsDataService, getTrainerTableDataService, updateAccountEvaluatorMappingDataService, updateAgentTrainingCommentsDataService, updateAquaaAcknowledgementDataService, updateAquaaAdminAccountsDataService, updateAquaaAdminContactTypeDataService, updateAquaaAdminQuestionsDataService, updateAquaaEvaluationsDeleteService, updateAquaaIcedDataService, updateAquaaMappingDataService, updateEvaluationFormDataService, updateIcedDataService, updateNewEvaluatorDataService, updateSubmittedCommentsDataService, updateTrainingAssignmentDataService, updateTrainingCommentsDataService } from "../../services/Applications/aquaa.service";
import AquaaURLs from "../../constants/Applications/aquaa-urls";
import { updateAccountEvaluatorMappingDataSuccess, updateAgentTrainingCommentsDataSuccess, updateAquaaAcknowledgementDataSuccess, updateAquaaAdminAccountsDataSuccess, updateAquaaEvaluationsDeleteSuccess, updateAquaaIcedDataSuccess, updateAquaaMappingDataSuccess, updateEvaluationFormDataSuccess, updateIcedDataSuccess, updateNewEvaluatorDataSuccess, updateSubmittedCommentsDataSuccess, updateTrainingAssignmentDataSuccess, updateTrainingCommentsDataSuccess } from "../../actions/Applications/aquaa.action";
import { getAquaaAdminContactTypeTableDataService, getAquaaIcedEvaluationsDataService, getAccountEvaluatorEvaluatorsDataService } from './../../services/Applications/aquaa.service';
import { updateAquaaAdminContactTypeDataSuccess, updateAquaaAdminQuestionsDataSuccess } from './../../actions/Applications/aquaa.action';


function* fetchAquaaAccounts(action){
    try {
      const response = yield call(getAquaaAccountsDataService, AquaaURLs('GET_AQUAA_ACCOUNTS_DATA'));
      console.log("Fetching Aquaa Accounts Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ACCOUNTS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Accounts Data");
      console.log(error);
    }
  }

  function* fetchAquaaAgents({account,location,channel}){
    let items = {
      account: account,
      location:location,
    channel:channel
  }
    try {
      const response = yield call(getAquaaAgentsDataService, AquaaURLs('GET_AQUAA_AGENTS_DATA',items));
      console.log("Fetching Aquaa Agents Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_AGENTS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Agents Data");
      console.log(error);
    }
  }

  function* fetchAquaaChannels({account,location}){
    let items = {
      account: account,
      location: location
  }
    try {
      const response = yield call(getAquaaChannelsDataService, AquaaURLs('GET_AQUAA_CHANNELS_DATA',items));
      console.log("Fetching Aquaa Channels Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_CHANNELS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Channels Data");
      console.log(error);
    }
  }

  function* fetchAquaaLanguages({account,agent,channel,location}){
    let items = {
      account: account,
      agent: agent,
      channel: channel,
      location:location
  }
    try {
      const response = yield call(getAquaaLanguagesDataService, AquaaURLs('GET_AQUAA_LANGUAGES_DATA',items));
      console.log("Fetching Aquaa Languages Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_LANGUAGES_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Languages Data");
      console.log(error);
    }
  }

  function* fetchAquaaLocations({account}){
    let items = {
      account: account,
  }
    try {
      const response = yield call(getAquaaLocationsDataService, AquaaURLs('GET_AQUAA_LOCATIONS_DATA',items));
      console.log("Fetching Aquaa Locations Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_LOCATIONS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Locations Data");
      console.log(error);
    }
  }

   function* fetchAquaaValidFrom(){
    try {
      const response = yield call(getAquaaValidFromDataService, AquaaURLs('GET_AQUAA_VALIDFROM_DATA'));
      console.log("Fetching Aquaa Valid From Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_VALIDFROM_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Valid From Data");
      console.log(error);
    }
  }

  function* fetchAquaaAWS({account,agent,channel,language,location,from,to}){
    let items = {
      account: account,
      agent: agent,
      channel: channel,
      language: language,
      location: location,
      from:from,
      to:to
  }
    try {
      const response = yield call(getAquaaAWSDataService, AquaaURLs('GET_AQUAA_AWS_DATA',items));
      console.log("Fetching Aquaa AWS Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_AWS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa AWS Data");
      console.log(error);
    }
  }

  function* fetchEvaluationFormData({contactId,contactFormID,countryID}){
    let items = {
      contactId: contactId,
      contactFormID: contactFormID,
      countryID:countryID
    }
    try {
      const response = yield call(getEvaluationFormDataService, AquaaURLs('GET_EVALUATION_FORM_DATA',items));
      console.log("Fetching Evaluation Form Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.EVALUATION_FORM_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Evaluation Form Data");
      console.log(error);
    }
  }

  function* updateEvaluationFormData({ payload: id }) {
      try {
          const response = yield call(updateEvaluationFormDataService, AquaaURLs('UPDATE_EVALUATION_FORM_DATA'), id);
          if (response.data) {
              yield put(
                updateEvaluationFormDataSuccess()
              );
              console.log(response.data)
          }
      } catch (error) {
          console.log("Error while updating Evaluation Form data", error);
      }
  }

  function* fetchSavedEvaluationsData(action){
    try {
      const response = yield call(getSavedEvaluationsDataService, AquaaURLs('GET_SAVED_EVALUATIONS_DATA'));
      console.log("Fetching saved Evaluations Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.SAVED_EVALUATIONS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching saved Evaluations Data");
      console.log(error);
    }
  }

  function* fetchSubmittedEvaluationsData(action){
    try {
      const response = yield call(getSubmittedEvaluationsDataService, AquaaURLs('GET_SUBMITTED_EVALUATIONS_DATA'));
      console.log("Fetching submitted Evaluations Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.SUBMITTED_EVALUATIONS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching submitted Evaluations Data");
      console.log(error);
    }
  }

  function* fetchSavedEvaluationFormData({evaluationId}){
    let items = {
      evaluationId: evaluationId
    }
    try {
      const response = yield call(getSavedEvaluationFormDataService, AquaaURLs('GET_SAVED_EVALUATION_FORM_DATA',items));
      console.log("Fetching Saved Evaluation Form Data API is success",response);
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.SAVED_EVALUATION_FORM_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Saved Evaluation Form Data");
      console.log(error);
    }
  }

  function* fetchAquaaNonASDAccounts(action){
    try {
      const response = yield call(getAquaaNonASDAccountsDataService, AquaaURLs('GET_AQUAA_NONASD_ACCOUNTS_DATA'));
      console.log("Fetching Aquaa non ASD Accounts Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_NONASD_ACCOUNTS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa non ASD Accounts Data");
      console.log(error);
    }
  }

  function* fetchAquaaNonASDChannels({account,location}){
    let items = {
      account: account,
      location:location
  }
    try {
      const response = yield call(getAquaaNonASDChannelsDataService, AquaaURLs('GET_AQUAA_NONASD_CHANNELS_DATA',items));
      console.log("Fetching Aquaa Non ASD Channels Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_NONASD_CHANNELS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Non ASD Channels Data");
      console.log(error);
    }
  }

  function* fetchAquaaNonASDLocations({account}){
    let items = {
      account: account,
  }
    try {
      const response = yield call(getAquaaNonASDLocationsDataService, AquaaURLs('GET_AQUAA_NONASD_LOCATIONS_DATA',items));
      console.log("Fetching Aquaa Non ASD Locations Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_NONASD_LOCATIONS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Non ASD Locations Data");
      console.log(error);
    }
  }

  function* fetchAquaaNonASDLanguages({account,location}){
    let items = {
      account: account,
      location: location
  }
    try {
      const response = yield call(getAquaaNonASDLanguagesDataService, AquaaURLs('GET_AQUAA_NONASD_LANGUAGES_DATA',items));
      console.log("Fetching Aquaa Non ASD Languages Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_NONASD_LANGUAGES_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Non ASD Languages Data");
      console.log(error);
    }
  }

  function* fetchAquaaNonASDAgents({email}){
    let items = {
      email: email
  }
    try {
      const response = yield call(getAquaaNonASDAgentsDataService, AquaaURLs('GET_AQUAA_NONASD_AGENTS_DATA',items));
      console.log("Fetching Aquaa Non ASD Agents Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_NONASD_AGENTS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Non ASD Agents Data");
      console.log(error);
    }
  }

  function* fetchAdditionalRecipients({email}){
    let items = {
      email: email
  }
    try {
      const response = yield call(getAdditionalReciepientsDataService, AquaaURLs('GET_ADDITIONAL_RECIPIENTS',items));
      console.log("Fetching Additional Reciepients Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.ADDITIONAL_RECIPIENTS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Additional Reciepient Data");
      console.log(error);
    }
  }

  function* fetchNonASDEvaluationFormData({account,agent,channel,language,location,contactTypeID}){
    let items = {
      account:account,
      agent:agent,
      channel:channel,
      language:language,
      location:location,
      contactTypeID:contactTypeID
    }
    try {
      const response = yield call(getNonASDEvaluationFormDataService, AquaaURLs('GET_NONASD_EVALUATION_FORM_DATA',items));
      console.log("Fetching Non ASD Evaluation Form Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.NONASD_EVALUATION_FORM_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Non ASD Evaluation Form Data");
      console.log(error);
    }
  }

  function* fetchAgentEvaluationsData(action){
    try {
      const response = yield call(getAgentEvaluationsDataService, AquaaURLs('GET_AGENT_EVALUATIONS_DATA'));
      console.log("Fetching agent Evaluations Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AGENT_EVALUATIONS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching agent Evaluations Data");
      console.log(error);
    }
  }

  function* fetchAquaaAdminAccountsData(action){
    try {
      const response = yield call(getAquaaAdminAccountsDataService, AquaaURLs('GET_AQUAA_ADMIN_ACCOUNTS_DATA'));
      console.log("Fetching Aquaa Admin Accounts Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ADMIN_ACCOUNTS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Admin Accounts Data");
      console.log(error);
    }
  }

  function* fetchAquaaAdminAccountsTableData(action){
    try {
      const response = yield call(getAquaaAdminAccountsTableDataService, AquaaURLs('GET_AQUAA_ADMIN_ACCOUNTS_TABLE_DATA'));
      console.log("Fetching Aquaa Admin Accounts Table Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ADMIN_ACCOUNTS_TABLE_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Admin Accounts Table Data");
      console.log(error);
    }
  }

  function* fetchAquaaAdminChannelsData(action){
    try {
      const response = yield call(getAquaaAdminChannelsDataService, AquaaURLs('GET_AQUAA_ADMIN_CHANNELS_DATA'));
      console.log("Fetching Aquaa Admin Channels Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ADMIN_CHANNELS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Admin Channels Data");
      console.log(error);
    }
  }

  function* fetchAquaaAdminContactTypeTableData(action){
    try {
      const response = yield call(getAquaaAdminContactTypeTableDataService, AquaaURLs('GET_AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA'));
      console.log("Fetching Aquaa Admin Contact Type Table Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Admin Contact Type Table Data");
      console.log(error);
    }
  }

  function* updateAquaaAdminAccountsData({ payload: id }) {
      try {
          const response = yield call(updateAquaaAdminAccountsDataService, AquaaURLs('UPDATE_AQUAA_ADMIN_ACCOUNT_DATA'), id);
          if (response.data) {
              yield put(
                updateAquaaAdminAccountsDataSuccess()
              );
              console.log(response.data)
          }
      } catch (error) {
          console.log("Error while updating Admin Account data", error);
      }
  }

  function* updateAquaaAdminContactTypeData({ payload: id }) {
      try {
          const response = yield call(updateAquaaAdminContactTypeDataService, AquaaURLs('UPDATE_AQUAA_ADMIN_CONTACTTYPE_DATA_START'), id);
          if (response.data) {
              yield put(
                updateAquaaAdminContactTypeDataSuccess()
              );
              console.log(response.data)
          }
      } catch (error) {
          console.log("Error while updating Admin Contact Type data", error);
      }
  }

   function* fetchAquaaQuestionAssessmentsData(action){
    try {
      const response = yield call(getAquaaQuestionAssessmentsDataService, AquaaURLs('GET_AQUAA_QUESTION_ASSESSMENTS_DATA'));
      console.log("Fetching Aquaa Question Assessments Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_QUESTION_ASSESSMENTS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Question assessments Data");
      console.log(error);
    }
  }

  function* fetchAquaaAdminQuestionsTableData(action){
    try {
      const response = yield call(getAquaaAdminQuestionsTableDataService, AquaaURLs('GET_AQUAA_ADMIN_QUESTIONS_TABLE_DATA'));
      console.log("Fetching Aquaa Admin Questions Table Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ADMIN_QUESTIONS_TABLE_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Admin Questions Table Data");
      console.log(error);
    }
  }

   function* updateAquaaAdminQuestionsData({ payload: id }) {
      try {
          const response = yield call(updateAquaaAdminQuestionsDataService, AquaaURLs('UPDATE_AQUAA_ADMIN_QUESTIONS_DATA'), id);
          if (response.data) {
              yield put(
                updateAquaaAdminQuestionsDataSuccess()
              );
              console.log(response.data)
          }
      } catch (error) {
          console.log("Error while updating Admin Questions data", error);
      }
  }

  function* updateAquaaAcknowledgementData({ payload: id }) {
      try {
          const response = yield call(updateAquaaAcknowledgementDataService, AquaaURLs('UPDATE_AQUAA_ACKNOWLEDGEMENT_DATA'), id);
          if (response.data) {
              yield put(
                updateAquaaAcknowledgementDataSuccess()
              );
              console.log(response.data)
          }
      } catch (error) {
          console.log("Error while updating Acknowledgement data", error);
      }
  }

   function* fetchAquaaMappingAccountsData(action){
    try {
      const response = yield call(getAquaaMappingAccountsService, AquaaURLs('GET_AQUAA_MAPPING_ACCOUNTS'));
      console.log("Fetching Aquaa Mapping Accounts Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_MAPPING_ACCOUNTS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Mapping Accounts Data");
      console.log(error);
    }
  }

   function* fetchAquaaMappingContacttypeFormsData(action){
    try {
      const response = yield call(getAquaaMappingContacttypeFormsService, AquaaURLs('GET_AQUAA_MAPPING_CONTACTTYPE_FORMS'));
      console.log("Fetching Aquaa Mapping Contacttype Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_MAPPING_CONTACTTYPE_FORMS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Mapping Contacttype Data");
      console.log(error);
    }
  }

  function* fetchAquaaMappingCountriesData({account}){
    let items = {
      account:account,
    }
    try {
      const response = yield call(getAquaaMappingCountriesService, AquaaURLs('GET_AQUAA_MAPPING_COUNTRIES',items));
      console.log("Fetching Aquaa Mapping Countries Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_MAPPING_COUNTRIES,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Mapping Countries Data");
      console.log(error);
    }
  }

   function* fetchAquaaMappingSectionsData(action){
    try {
      const response = yield call(getAquaaMappingSectionsService, AquaaURLs('GET_AQUAA_MAPPING_SECTIONS'));
      console.log("Fetching Aquaa Mapping Sections Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_MAPPING_SECTIONS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Mapping Sections Data");
      console.log(error);
    }
  }

   function* fetchAquaaMappingQuestionsData({question}){
    let items = {
      question:question,
    }
    try {
      const response = yield call(getAquaaMappingQuestionsService, AquaaURLs('GET_AQUAA_MAPPING_QUESTIONS',items));
      console.log("Fetching Aquaa Mapping Questions Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_MAPPING_QUESTIONS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Mapping Questions Data");
      console.log(error);
    }
  }

  function* fetchAquaaMappingParameterTypeData(action){
    try {
      const response = yield call(getAquaaMappingParameterTypeService, AquaaURLs('GET_AQUAA_MAPPING_PARAMETERTYPE'));
      console.log("Fetching Aquaa Mapping Parameter type Data API is success");
      console.log(response);
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_MAPPING_PARAMETERTYPE,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Mapping Prameter type Data");
      console.log(error);
    }
  }

  function* updateAquaaMappingData({ payload: id }) {
      try {
          const response = yield call(updateAquaaMappingDataService, AquaaURLs('UPDATE_AQUAA_MAPPING_DATA'), id);
          if (response.data) {
              yield put(
                updateAquaaMappingDataSuccess()
              );
              console.log(response.data)
          }
      } catch (error) {
          console.log("Error while updating Mapping data", error);
      }
  }

  function* fetchAquaaEvaluationsDelete({parameter,value,roleid}){
     let items = {
      parameter:parameter,
      value:value,
      roleid:roleid
    }
    try {
      const response = yield call(getAquaaEvaluationsDeleteService, AquaaURLs('GET_AQUAA_EVALUATIONS_DELETE',items));
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_EVALUATIONS_DELETE,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Evaluations Delete Data");
    }
  }

  function* updateAquaaEvaluationsDelete({ payload: id }) {
      try {
          const response = yield call(updateAquaaEvaluationsDeleteService, AquaaURLs('UPDATE_AQUAA_EVALUATIONS_DELETE'), id);
          if (response.data) {
              yield put(
                updateAquaaEvaluationsDeleteSuccess()
              );
              console.log(response.data)
          }
      } catch (error) {
          console.log("Error while updating Aquaa Evaluations Delete Data", error);
      }
  }

  function* fetchAquaaValidateTicketNo({ticketNo}){
     let items = {
      ticketNo:ticketNo,
    }
    try {
      const response = yield call(getAquaaValidateTicketNoService, AquaaURLs('GET_AQUAA_VALIDATE_TICKET_NO',items));
      console.log("Fetching Aquaa Validate Ticket No is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_VALIDATE_TICKET_NO,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Validate Ticket No Data");
    }
  }

   function* fetchAquaaIcedAgents(action){
    try {
      const response = yield call(getAquaaIcedAgentsService, AquaaURLs('GET_AQUAA_ICED_AGENTS'));
      console.log("Fetching Aquaa Iced Agents Data API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ICED_AGENTS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Iced Agents Data");
    }
  }

  function* fetchAquaaIcedAccounts(action){
    try {
      const response = yield call(getAquaaIcedAccountsService, AquaaURLs('GET_AQUAA_ICED_ACCOUNTS'));
      console.log("Fetching Aquaa Iced Accounts Data API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ICED_ACCOUNTS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Iced Accounts Data");
    }
  }

  function* fetchAquaaIcedTableData({StartDT,EndDT,Agent,Account,TicketNumber}){
    let items = {
      StartDT:StartDT,
      EndDT:EndDT,
      Agent:Agent,
      Account:Account,
      TicketNumber:TicketNumber
    }
    try {
      const response = yield call(getAquaaIcedTableDataService, AquaaURLs('GET_AQUAA_ICED_TABLE_DATA',items));
      console.log("Fetching Aquaa Iced Table Data API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ICED_TABLE_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Iced Table Data");
    }
  }

  function* fetchAquaaIcedL1Category(action){
    try {
      const response = yield call(getAquaaIcedL1CategoryService, AquaaURLs('GET_AQUAA_ICED_L1_CATEGORY'));
      console.log("Fetching Aquaa Iced L1 Category Data API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ICED_L1_CATEGORY,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Iced L1 Category Data");
    }
  }

  function* fetchAquaaIcedL2Category(action){
    try {
      const response = yield call(getAquaaIcedL2CategoryService, AquaaURLs('GET_AQUAA_ICED_L2_CATEGORY'));
      console.log("Fetching Aquaa Iced L2 Category Data API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ICED_L2_CATEGORY,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Iced L2 Category Data");
    }
  }

  function* updateAquaaIcedData({ payload: id }) {
      try {
          const response = yield call(updateAquaaIcedDataService, AquaaURLs('UPDATE_AQUAA_ICED_DATA'), id);
          if (response.data) {
              yield put(
                updateAquaaIcedDataSuccess()
              );
              console.log(response.data)
          }
      } catch (error) {
          console.log("Error while updating Aquaa ICED Data", error);
      }
  }

  function* fetchAquaaIcedEvaluationsData({roleId}){
     let items = {
      roleId:roleId, 
    }
    try {
      const response = yield call(getAquaaIcedEvaluationsDataService, AquaaURLs('GET_AQUAA_ICED_EVALUATIONS_DATA',items));
      console.log("Fetching Aquaa Iced Evaluations Data API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.AQUAA_ICED_EVALUATIONS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Aquaa Iced Evaluations Data");
    }
  }

  function* fetchAccountEvaluatorAccountsData({roleId}){
    let items = {
      roleId:roleId, 
    }
    try {
      const response = yield call(getAccountEvaluatorAccountsDataService, AquaaURLs('GET_ACCOUNT_EVALUATOR_ACCOUNTS_DATA',items));
      console.log("Fetching Acc Ev Accounts API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.ACCOUNT_EVALUATOR_ACCOUNTS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Acc Ev Accounts Data");
    }
  }

  function* fetchAccountEvaluatorEvaluatorsData({roleId}){
    let items = {
      roleId:roleId, 
    }
    try {
      const response = yield call(getAccountEvaluatorEvaluatorsDataService, AquaaURLs('GET_ACCOUNT_EVALUATOR_EVALUATORS_DATA',items));
      console.log("Fetching Acc Ev Evaluators API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.ACCOUNT_EVALUATOR_EVALUATORS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Evaluators Ev Accounts Data");
    }
  }

  function* fetchAccountEvaluatorTableData({accountId,evaluatorId,roleId}){
    let items = {
      accountId:accountId,
      evaluatorId:evaluatorId,
      roleId:roleId, 
    }
    try {
      const response = yield call(getAccountEvaluatorTableDataService, AquaaURLs('GET_ACCOUNT_EVALUATOR_TABLE_DATA',items));
      console.log("Fetching Acc Ev Table API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.ACCOUNT_EVALUATOR_TABLE_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Acc Ev Table Data");
    }
  }

  function* updateAccountEvaluatorMappingData({ payload: id ,callback}) {
      try {
          const response = yield call(updateAccountEvaluatorMappingDataService, AquaaURLs('UPDATE_ACCOUNT_EVALUATOR_MAPPING_DATA'), id);
          if (response.data) {
              yield put(
                updateAccountEvaluatorMappingDataSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating Account Evaluator Mapping Data", error);
      }
  }

  function* updateNewEvaluatorData({ payload: id ,callback}) {
      try {
          const response = yield call(updateNewEvaluatorDataService, AquaaURLs('UPDATE_NEW_EVALUATOR_DATA'), id);
          if (response.data) {
              yield put(
                updateNewEvaluatorDataSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating New Evaluator Data", error);
      }
  }

  function* fetchAccountEvaluatorUsersData({agent}){
    let items = {
      agent:agent, 
    }
    try {
      const response = yield call(getAccountEvaluatorUsersDataService, AquaaURLs('GET_ACCOUNT_EVALUATOR_USERS_DATA',items));
      console.log("Fetching Acc Ev Users API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.ACCOUNT_EVALUATOR_USERS_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Users Ev Accounts Data");
    }
  }

  function* fetchIcedReportsAccountsData({roleId}){
    let items = {
      roleId:roleId, 
    }
    try {
      const response = yield call(getIcedReportsAccountsDataService, AquaaURLs('GET_ICED_REPORTS_ACCOUNTS',items));
      console.log("Fetching ICED Acc API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.ICED_REPORTS_ACCOUNTS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching ICED Accounts Data");
    }
  }

  function* fetchIcedMasterData({roleId}){
    let items = {
      roleId:roleId, 
    }
    try {
      const response = yield call(getIcedMasterDataService, AquaaURLs('GET_ICED_MASTER_DATA',items));
      console.log("Fetching ICED Master API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.ICED_MASTER_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching ICED Master Data");
    }
  }

  function* updateIcedData({ payload: id ,callback}) {
      try {
          const response = yield call(updateIcedDataService, AquaaURLs('UPDATE_ICED_DATA'), id);
          if (response.data) {
              yield put(
                updateIcedDataSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating Iced Data", error);
      }
  }

  function* fetchIcedTableData(){
    try {
      const response = yield call(getIcedTableDataService, AquaaURLs('GET_ICED_TABLE_DATA'));
      console.log("Fetching ICED Table API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.ICED_TABLE_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching ICED Table Data");
    }
  }

   function* updateSubmittedCommentsData({ payload: id ,callback}) {
      try {
          const response = yield call(updateSubmittedCommentsDataService, AquaaURLs('UPDATE_SUBMITTED_COMMENTS_DATA'), id);
          if (response.data) {
              yield put(
                updateSubmittedCommentsDataSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating Submitted Comments Data", error);
      }
  }

  function* fetchRecommendationsTableData({Recommendation,Status,AssignedToMe} ){
     let items = {
      Recommendation:Recommendation,
      Status:Status,
      AssignedToMe:AssignedToMe
  }
    try {
      const response = yield call(getRecommendationsTableDataService, AquaaURLs('GET_RECOMMENDATIONS_TABLE_DATA',items));
      console.log("Fetching Recommendations Table API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.RECOMMENDATIONS_TABLE_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Recommendations Table Data");
    }
  }

  function* updateTrainingAssignmentData({ payload: id ,callback}) {
      try {
          const response = yield call(updateTrainingAssignmentDataService, AquaaURLs('UPDATE_TRAINING_ASSIGNMENT_DATA'), id);
          if (response.data) {
              yield put(
                updateTrainingAssignmentDataSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating Training Assignment Data", error);
      }
  }

  function* updateTrainingCommentsData({ payload: id ,callback}) {
      try {
          const response = yield call(updateTrainingCommentsDataService, AquaaURLs('UPDATE_TRAINING_COMMENTS_DATA'), id);
          if (response.data) {
              yield put(
                updateTrainingCommentsDataSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating Training Comments Data", error);
      }
  }

  function* fetchTrainerTableData(){
    try {
      const response = yield call(getTrainerTableDataService, AquaaURLs('GET_TRAINER_TABLE_DATA'));
      console.log("Fetching Trainer Table API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.TRAINER_TABLE_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Trainer Table Data");
    }
  }

   function* updateAgentTrainingCommentsData({ payload: id ,callback}) {
      try {
          const response = yield call(updateAgentTrainingCommentsDataService, AquaaURLs('UPDATE_AGENT_TRAINING_COMMENTS_DATA'), id);
          if (response.data) {
              yield put(
                updateAgentTrainingCommentsDataSuccess()
              );
              console.log(response.data)
               if (callback && typeof callback === 'function') {
        callback(); 
      }
          }
      } catch (error) {
          console.log("Error while updating Agent Training Comments Data", error);
      }
  }

  function* fetchRecommendationsDropdownData(){
    
    try {
      const response = yield call(getRecommendationsDropdownDataService, AquaaURLs('GET_RECOMMENDATIONS_DROPDOWN_DATA'));
      console.log("Fetching Recommendations Dropdown API is success");
      if (response.data) {
        yield put({
          type: AquaaActionTypes.RECOMMENDATIONS_DROPDOWN_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log("Error while fetching Recommendations Dropdown Data");
    }
  }


  function* watchGetRequest() {
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ACCOUNTS_DATA, fetchAquaaAccounts); 
    yield takeEvery(AquaaActionTypes.GET_AQUAA_AGENTS_DATA, fetchAquaaAgents);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_CHANNELS_DATA, fetchAquaaChannels);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_LANGUAGES_DATA, fetchAquaaLanguages);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_LOCATIONS_DATA, fetchAquaaLocations);  
    yield takeEvery(AquaaActionTypes.GET_AQUAA_VALIDFROM_DATA,fetchAquaaValidFrom);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_AWS_DATA, fetchAquaaAWS);
    yield takeEvery(AquaaActionTypes.GET_EVALUATION_FORM_DATA, fetchEvaluationFormData);
    yield takeEvery(AquaaActionTypes.UPDATE_EVALUATION_FORM_DATA_START, updateEvaluationFormData);  
    yield takeEvery(AquaaActionTypes.GET_SAVED_EVALUATIONS_DATA, fetchSavedEvaluationsData);
    yield takeEvery(AquaaActionTypes.GET_SUBMITTED_EVALUATIONS_DATA, fetchSubmittedEvaluationsData);
    yield takeEvery(AquaaActionTypes.GET_SAVED_EVALUATION_FORM_DATA, fetchSavedEvaluationFormData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_NONASD_ACCOUNTS_DATA, fetchAquaaNonASDAccounts);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_NONASD_CHANNELS_DATA, fetchAquaaNonASDChannels);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_NONASD_LOCATIONS_DATA, fetchAquaaNonASDLocations);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_NONASD_LANGUAGES_DATA, fetchAquaaNonASDLanguages);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_NONASD_AGENTS_DATA, fetchAquaaNonASDAgents);
    yield takeEvery(AquaaActionTypes.GET_ADDITIONAL_RECIPIENTS, fetchAdditionalRecipients);
    yield takeEvery(AquaaActionTypes.GET_NONASD_EVALUATION_FORM_DATA, fetchNonASDEvaluationFormData);
    yield takeEvery(AquaaActionTypes.GET_AGENT_EVALUATIONS_DATA, fetchAgentEvaluationsData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ADMIN_ACCOUNTS_DATA, fetchAquaaAdminAccountsData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ADMIN_ACCOUNTS_TABLE_DATA, fetchAquaaAdminAccountsTableData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ADMIN_CHANNELS_DATA, fetchAquaaAdminChannelsData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA, fetchAquaaAdminContactTypeTableData);
    yield takeEvery(AquaaActionTypes.UPDATE_AQUAA_ADMIN_ACCOUNT_DATA_START, updateAquaaAdminAccountsData);
    yield takeEvery(AquaaActionTypes.UPDATE_AQUAA_ADMIN_CONTACTTYPE_DATA_START, updateAquaaAdminContactTypeData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_QUESTION_ASSESSMENTS_DATA, fetchAquaaQuestionAssessmentsData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ADMIN_QUESTIONS_TABLE_DATA, fetchAquaaAdminQuestionsTableData);
    yield takeEvery(AquaaActionTypes.UPDATE_AQUAA_ADMIN_QUESTIONS_DATA_START, updateAquaaAdminQuestionsData);
    yield takeEvery(AquaaActionTypes.UPDATE_AQUAA_ACKNOWLEDGEMENT_DATA_START, updateAquaaAcknowledgementData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_MAPPING_ACCOUNTS, fetchAquaaMappingAccountsData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_MAPPING_CONTACTTYPE_FORMS, fetchAquaaMappingContacttypeFormsData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_MAPPING_COUNTRIES, fetchAquaaMappingCountriesData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_MAPPING_SECTIONS, fetchAquaaMappingSectionsData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_MAPPING_QUESTIONS, fetchAquaaMappingQuestionsData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_MAPPING_PARAMETERTYPE, fetchAquaaMappingParameterTypeData);
    yield takeEvery(AquaaActionTypes.UPDATE_AQUAA_MAPPING_DATA_START, updateAquaaMappingData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_EVALUATIONS_DELETE, fetchAquaaEvaluationsDelete);
    yield takeEvery(AquaaActionTypes.UPDATE_AQUAA_EVALUATIONS_DELETE_START, updateAquaaEvaluationsDelete);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_VALIDATE_TICKET_NO, fetchAquaaValidateTicketNo);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ICED_AGENTS, fetchAquaaIcedAgents);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ICED_ACCOUNTS, fetchAquaaIcedAccounts);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ICED_TABLE_DATA, fetchAquaaIcedTableData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ICED_L1_CATEGORY, fetchAquaaIcedL1Category);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ICED_L2_CATEGORY, fetchAquaaIcedL2Category);
    yield takeEvery(AquaaActionTypes.UPDATE_AQUAA_ICED_DATA_START, updateAquaaIcedData);
    yield takeEvery(AquaaActionTypes.GET_AQUAA_ICED_EVALUATIONS_DATA, fetchAquaaIcedEvaluationsData);
    yield takeEvery(AquaaActionTypes.GET_ACCOUNT_EVALUATOR_ACCOUNTS_DATA, fetchAccountEvaluatorAccountsData);
    yield takeEvery(AquaaActionTypes.GET_ACCOUNT_EVALUATOR_EVALUATORS_DATA, fetchAccountEvaluatorEvaluatorsData);
    yield takeEvery(AquaaActionTypes.GET_ACCOUNT_EVALUATOR_TABLE_DATA, fetchAccountEvaluatorTableData);
    yield takeEvery(AquaaActionTypes.UPDATE_ACCOUNT_EVALUATOR_MAPPING_DATA_START, updateAccountEvaluatorMappingData);
    yield takeEvery(AquaaActionTypes.UPDATE_NEW_EVALUATOR_DATA_START, updateNewEvaluatorData);
    yield takeEvery(AquaaActionTypes.GET_ACCOUNT_EVALUATOR_USERS_DATA, fetchAccountEvaluatorUsersData);
    yield takeEvery(AquaaActionTypes.GET_ICED_REPORTS_ACCOUNTS, fetchIcedReportsAccountsData);
    yield takeEvery(AquaaActionTypes.GET_ICED_MASTER_DATA, fetchIcedMasterData);
    yield takeEvery(AquaaActionTypes.UPDATE_ICED_DATA_START, updateIcedData);
    yield takeEvery(AquaaActionTypes.GET_ICED_TABLE_DATA, fetchIcedTableData);
    yield takeEvery(AquaaActionTypes.UPDATE_SUBMITTED_COMMENTS_DATA_START, updateSubmittedCommentsData);
    yield takeEvery(AquaaActionTypes.GET_RECOMMENDATIONS_TABLE_DATA, fetchRecommendationsTableData);
    yield takeEvery(AquaaActionTypes.UPDATE_TRAINING_ASSIGNMENT_DATA_START, updateTrainingAssignmentData);
    yield takeEvery(AquaaActionTypes.UPDATE_TRAINING_COMMENTS_DATA_START, updateTrainingCommentsData);
    yield takeEvery(AquaaActionTypes.GET_TRAINER_TABLE_DATA, fetchTrainerTableData);
    yield takeEvery(AquaaActionTypes.UPDATE_AGENT_TRAINING_COMMENTS_DATA_START, updateAgentTrainingCommentsData);
    yield takeEvery(AquaaActionTypes.GET_RECOMMENDATIONS_DROPDOWN_DATA, fetchRecommendationsDropdownData);












  }
  
  export default function* aquaaSagas() {
    yield all([watchGetRequest()]);
  }
  